import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col items-center justify-center p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileView = _resolveComponent("MobileView")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["fixed inset-0 z-30", _ctx.loading ? 'pointer-events-none' : '']),
        style: {
        backgroundColor: 'rgba(0,0,0,.7)'
      }
      }, [
        _createVNode(_component_MobileView, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _: 3
        })
      ], 2)
    ]),
    _: 3
  }))
}